/**
 * 日志详情
  GET /assistant/oplog/list
  接口ID：206035395
  接口地址：https://app.apifotwitter.com/link/project/4564145/apis/api-206035395
 */

import { get } from "../utils/fetch";

/**
 * AuthResult
 */

/**
 * JsonDiffPath
 *
 * com.micun.common.diff.render.JsonDiffPath
 */

/**
 * JsonModifyValue
 */

export var apiAssistantOplogList = function apiAssistantOplogList(query) {
  return get({
    url: '/assistant/oplog/list',
    query: query
  });
};